import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useContext, useMemo, useState } from 'react';
var LinkCreatePluginsContext = /*#__PURE__*/createContext(null);
export var LinkCreatePluginsProvider = function LinkCreatePluginsProvider(_ref) {
  var plugins = _ref.plugins,
    propEntityKey = _ref.entityKey,
    children = _ref.children;
  var _useState = useState(propEntityKey),
    _useState2 = _slicedToArray(_useState, 1),
    entityKey = _useState2[0];
  var value = useMemo(function () {
    var _plugins$find;
    return {
      activePlugin: (_plugins$find = plugins.find(function (plugin) {
        return plugin.key === entityKey;
      })) !== null && _plugins$find !== void 0 ? _plugins$find : null
    };
  }, [entityKey, plugins]);
  return /*#__PURE__*/React.createElement(LinkCreatePluginsContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};
export var useLinkCreatePlugins = function useLinkCreatePlugins() {
  var value = useContext(LinkCreatePluginsContext);
  if (!value) {
    throw new Error('useLinkCreatePlugins used outside of LinkCreatePluginsProvider');
  }
  return value;
};